export const plugins = []

export const debug = process.env.NODE_ENV !== 'production'
